module.exports = __webpack_public_path__ + "static/media/5232.f116c490.jpg";